import { useNextRouter } from '@/data/Content/_NextRouter';
import { ContextModal } from '@/data/context/content';
import { PageLink, useNavigation } from '@/data/Navigation';
import { Tab, Tabs } from '@mui/material';
import React, { FC, useContext, useMemo, useState } from 'react';

export const CategoryTabs: FC = () => {
	const context = useContext(ContextModal);
	const { state } = context ?? {};
	const [value, setValue] = useState<string>('');
	const navigation = useNavigation();
	const router = useNextRouter();
	const routeFound = useMemo(
		() =>
			navigation.navigation
				? navigation.navigation.find((label) => {
						if (Array.isArray(state?.breadCrumbs)) {
							if (label.label === state?.breadCrumbs[0]?.label) {
								return label;
							}
						}
				  })
				: {
						label: '',
						url: '',
						children: [],
				  },
		[navigation, state?.breadCrumbs]
	);

	const category = useMemo(
		() =>
			routeFound?.children.find((cat: PageLink) =>
				Array.isArray(state?.breadCrumbs)
					? cat.label === state?.breadCrumbs[state?.breadCrumbs.length - 1]?.label
					: false
			),
		[routeFound, state?.breadCrumbs]
	);
	const handleChange = (event: React.SyntheticEvent, newValue: string) => {
		setValue(newValue);
		router.push(newValue);
	};
	if (category) {
		return (
			<Tabs
				value={value}
				onChange={handleChange}
				variant="scrollable"
				scrollButtons={false}
				aria-label="scrollable prevent tabs example"
			>
				{category?.children.map((categories) => (
					<Tab
						key={categories.label}
						sx={{
							fontSize: 'var(--font-size-sm)',
							color: '#2C2C2C',
							'&.Mui-focusVisible': {
								backgroundColor: '#0467D2',
							},
							'&.Mui-selected': {
								color: '#2C2C2C',
								fontWeight: '800',
							},
						}}
						value={categories.url}
						label={categories.label}
						wrapped
					/>
				))}
			</Tabs>
		);
	}

	return null;
};
